<template>
  <div
    class="lang-toggle"
    :class="{ 'lang-toggle--en': $store.state.lang === 'en' }"
  >
    <button
      type="button"
      class="lang-toggle__btn"
      :class="{ active: $store.state.lang === 'ko' }"
      @click="setLang('ko')"
    >
      한국어
    </button>
    <span class="lang-toggle__divider">|</span>
    <button
      type="button"
      class="lang-toggle__btn"
      :class="{ active: $store.state.lang === 'en' }"
      @click="setLang('en')"
    >
      English
    </button>
    <!-- <span v-if="checkLocale('zh')" class="lang-toggle__divider">|</span>
    <button
      v-if="checkLocale('zh')"
      type="button"
      class="lang-toggle__btn"
      :class="{ active: $store.state.lang === 'zh' }"
      @click="setLang('zh')"
    >
      中文
    </button>
    <span v-if="checkLocale('ja')" class="lang-toggle__divider">|</span>
    <button
      v-if="checkLocale('ja')"
      type="button"
      class="lang-toggle__btn"
      :class="{ active: $store.state.lang === 'ja' }"
      @click="setLang('ja')"
    >
      日本語
    </button> -->
  </div>
</template>

<script>
import { saveCookie } from "./store/cookie";

export default {
  methods: {
    setLang(locale) {
      if (this.$store.state.lang !== locale) {
        saveCookie("lang", locale);
        location.reload();
      }
    },
    checkLocale(lang) {
      const locale = (
        navigator.language ||
        navigator.userLanguage ||
        ""
      ).toLowerCase();

      return true;

      if (lang === "zh" && locale.startsWith("zh")) {
        return true;
      } else if (lang === "ja" && locale.startsWith("ja")) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.lang-toggle {
  position: fixed;
  top: 12px;
  left: 16px;
  z-index: 99;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.lang-toggle__btn {
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  color: #888;
  background: none;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: color 0.2s, background 0.2s;
}

.lang-toggle__btn:hover {
  color: #333;
}

.lang-toggle__btn.active {
  color: #2563eb;
  background: #eff6ff;
}

.lang-toggle__divider {
  color: #ddd;
  font-size: 12px;
  user-select: none;
}
</style>